import { Car } from '../../../../types/car';
import { IVehicleTile } from '../../../../types/vehicleTile';

import { getTileAvailabilityText } from '../../../../utilities/getTileAvailabilityText';
import { IViewedVehicleLocalStorage } from '../../utilities/types';

const isVehicleViewed = (stockNumber: number): boolean => {
    const viewedVehicleString = localStorage.getItem('viewedVehicles');
    const viewedVehicles: IViewedVehicleLocalStorage[] = viewedVehicleString ? JSON.parse(viewedVehicleString) : [];
    return viewedVehicles.some((v) => Number(v.stockNumber) === stockNumber);
};

const isNewForYou = (isNewArrival: boolean | undefined, stockNumber: number): boolean => {
    const vehicleHasBeenViewed = isVehicleViewed(stockNumber);
    return !!isNewArrival && !vehicleHasBeenViewed;
};

export const mapVehicleTileToCar = (vehicleTile: IVehicleTile, showRecentlyViewedBadge = true): Car => {
    const availabilityInfo = getTileAvailabilityText(vehicleTile);
    const transferText = availabilityInfo.transferText ?? vehicleTile.shippingText ?? '';
    const legacyTransferText =
        getTileAvailabilityText(vehicleTile, false).transferText ?? vehicleTile.shippingText ?? '';

    return {
        ...vehicleTile,
        // Using as since when we call getTileAvailabilityText with showStoreInTransferText as false, we know it will return a string or null, but the type definition allows for ReactNode as well.
        transferText: legacyTransferText as string,
        stockNumber: String(vehicleTile.stockNumber),
        price: vehicleTile.basePrice,
        distance: vehicleTile.distance ?? 0,
        engineType: vehicleTile.engineType ?? vehicleTile.transmission ?? '',
        location: {
            ...vehicleTile,
            transferText,
        },
        statusInfo: {
            isNewMatch: isNewForYou(vehicleTile.isNewArrival, vehicleTile.stockNumber),
            isPopular: undefined,
            hasPriceDrop: !!vehicleTile.hasPriceDrop,
            isSold: availabilityInfo.transferType === 'sold',
            isShipping: availabilityInfo.transferType === 'shipping-to',
            isReserved: ['off-lot', 'on-hold'].includes(availabilityInfo.transferType ?? '') || (!vehicleTile.isAvailableToTransact && !vehicleTile.isComingSoon),
            isComingSoon: !!vehicleTile.isComingSoon,
            isRecentlyViewed: showRecentlyViewedBadge && isVehicleViewed(vehicleTile.stockNumber),
        },
    };
};

export const hideSnackBarFromExternalScript = () => {
    const externalSnackbar = document.getElementById('parking-lot-snackbar');
    if (externalSnackbar) {
        externalSnackbar.style.display = 'none';
        setTimeout(() => {
            externalSnackbar.style.display = 'block';
        }, 2900);
    }
};
